var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-order"},[_c('div',{staticClass:"order-main"},[_c('NewOrderMain')],1),_c('div',{staticClass:"place-order-main"},[_c('PlaceOrder')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }